// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"87":"2791e6208f44cbcde05e","123":"a1631da5d449cac62f47","207":"783926bee488096de90b","324":"2e77452b3099558a3e36","556":"2d62ac2eda5075d68fe3","923":"17430c7270787a32fb76"}[chunkId] + ".bundle.js";
};